import { ChangeDetectorRef, Component, OnInit, ChangeDetectionStrategy } from "@angular/core";
import { MessageService } from "../../services/message.service";
import { MessageModel } from "../../models/message.model";
import { UtilityService } from "../../services/utility.service";
import { ActivatedRoute } from "@angular/router";
import { DialogService } from "../../services/dialog.service";
import { Observable } from "rxjs";
@Component({
  selector: "app-traffic-information",
  standalone: false,
  templateUrl: "./traffic-information.component.html",
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ["./traffic-information.component.scss"]
})
export class TrafficInformationComponent implements OnInit {
  message: MessageModel[] = [];

  constructor(
    private messageService: MessageService,
    private route: ActivatedRoute,
    private dialogService: DialogService,
    private cdr: ChangeDetectorRef
  ) {}

  ngOnInit(): void {
    this.messageService.clickNewMessage.subscribe(response=>{
      this.newMessage();
    });
    this.messageService.clickOpenInNewWindow.subscribe(response => {
      this.resetMessage();
    })

    this.route.paramMap.subscribe(params => {
      const id = params.get('messageId');
      if (id) {
        this.fetchMessage(id);
      }
    });
  }

  fetchMessage(id: string) {
    if (!id) {
      this.resetMessage();
    } else {

      this.messageService
        .getMessageVersions(id)
        .subscribe({
          next: (data: any) => {

            const versions = Array.isArray(data) ? data : [data];
            

            const messageModels = versions.map(v => {
              let messageModel = UtilityService.mapApiResponseToMessage(v);
              

              if (!UtilityService.validDate(messageModel.validFrom!)) {
                messageModel.validFrom = null;
              }
              if (!UtilityService.validDate(messageModel.validTo!)) {
                messageModel.validTo = null;
              }
              
              return messageModel;
            });
            

            this.message = messageModels;
            this.cdr.detectChanges();
          },
          error: (error) => {
            console.error('Failed to fetch message versions:', error);
            

            this.messageService.getMessageById(id).subscribe({
              next: (data: any) => {
                let messageModel = UtilityService.mapApiResponseToMessage(data);
                
                if (!UtilityService.validDate(messageModel.validFrom!)) {
                  messageModel.validFrom = null;
                }
                if (!UtilityService.validDate(messageModel.validTo!)) {
                  messageModel.validTo = null;
                }
                
                this.message = [messageModel];
                this.cdr.detectChanges();
              },
              error: (err) => console.error("Fetch message failed:", err)
            });
          }
        })
    }
  }

  newMessage(){
    this.message = [new MessageModel()];
    this.cdr.detectChanges();
  }
  
  resetMessage() {
    this.message = [];
    this.cdr.detectChanges();
  }
  
  canDeactivate(): Observable<boolean> | boolean {
    if (!this.messageService.hasChanges()) {
      return true;
    }

    return this.dialogService.unsavedNavigationConfirmation();
  }
}
